<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="color">mdi-brightness-6</v-icon>
      </template>
      <template #value>{{ illumination!=undefined ? illumination.toFixed(0) : '---' }}</template>
      <template #unit>{{ unit }}</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <IlluminationChartDialog v-if="dialog" v-model="dialog" :device="device" :endpoint="endpointId" :reportInterval="reportInterval" :unit="unit" @setting="showSettingsDialog"></IlluminationChartDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import IlluminationChartDialog from '@/components/chart/IlluminationChartDialog'

export default {
  name: 'IlluminateTile',
  mixins: [EndpointTile],
  components: {
    CenterizedTile,
    IconifiedTile,
    IlluminationChartDialog
  },
  computed: {
    reportInterval() {
      return this.info.configurations.reportInterval;
    },
    illumination() {
      return this.report.illumination;
    },
    unit() {
      let u = this.info.configurations.reportUnit;
      if (u)
        return this.$t(`unit.${u}`);
      else
        return '';
    },
    color() {
      return this.illumination != undefined ? 'primary' : 'color';
    }
  }
}
</script>
